export default __webpack_public_path__ + "static/media/bank-of-america.8825087c.svg";